import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateHotelExtra } from "../../api/apiHotelExtras";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateHotelExtra = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: editHotelExtra, isPending: isUpdate } = useMutation({
        mutationFn: ({ id, req }) => updateHotelExtra(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Hotel extra updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
            queryClient.invalidateQueries({ queryKey: ["hotelExtra"] });
            navigate("/hotel-extras");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update hotel extra");
        },
    });

    return { editHotelExtra, isUpdate };
};

export default useUpdateHotelExtra;
